export const LAYER_ROW_CLASS_NAME =
  'flex flex-row min-w-0 items-center gap-1 py-1 pr-1.5 rounded-md transition-colors';

export const LAYER_NAME_CLASS_NAME =
  'min-w-0 text-sm leading-none font-[450] flex-1 line-clamp-1 break-all overflow-hidden text-ellipsis';

export const LAYER_ICON_CLASS_NAME = 'size-5 shrink-0 flex items-center justify-center';

export const LAYER_EXPAND_BUTTON_CLASS_NAME =
  'flex shrink-0 items-center justify-center size-5 hover:bg-gray-100 dark:hover:bg-stone-800/50 rounded';

export const LAYER_CHEVRON_CLASS_NAME =
  'size-4 text-gray-600 stroke-2 stroke-current transition-all dark:text-white/70';
